@if (label(); as label) {
  <p-floatlabel variant="on">
    <ng-container [ngTemplateOutlet]="selectTemplate" />
    <label [for]="inputId">{{ label | transloco }}</label>
  </p-floatlabel>
} @else {
  <ng-container [ngTemplateOutlet]="selectTemplate" />
}

<ng-template #selectTemplate>
  <p-select
    [options]="options()"
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    [disabled]="disabled()"
    [placeholder]="placeholder() | transloco"
    [inputId]="inputId"
    optionLabel="directusKey"
    optionValue="value"
    [class]="styleClass()"
    [attr.data-testid]="testId()"
    appendTo="body"
  >
    <ng-template #item let-option>
      <div class="flex flex-col">
        <span>{{ option.directusKey | transloco }}</span>
        @if (option.descriptionKey) {
          <span class="text-xs text-gray-500 whitespace-normal">
            {{ option.descriptionKey | transloco }}
          </span>
        }
      </div>
    </ng-template>
    <ng-template #selectedItem let-option>
      {{ option.directusKey | transloco }}
    </ng-template>
  </p-select>
</ng-template>
